import Vue from "vue";

/**
 * Calcula a cor de texto contrastante (preto ou branco) para uma cor de fundo.
 * @param {string} color - A cor de fundo em formato #hex ou rgb().
 * @returns {string} - Retorna '#000000' para fundos claros e '#FFFFFF' para fundos escuros.
 */
function getContrastColor(color: string): string {
  if (
    !color ||
    color === "transparent" ||
    color.startsWith("rgba(0, 0, 0, 0)")
  ) {
    return "inherit";
  }

  let r: number, g: number, b: number;

  if (color.startsWith("#")) {
    let hex = color.substring(1);
    if (hex.length === 3)
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    if (hex.length !== 6) return "inherit";
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  } else if (color.startsWith("rgb")) {
    const parts = color.match(/(\d+)/g);
    if (!parts || parts.length < 3) return "inherit";
    [r, g, b] = parts.map(Number);
  } else {
    return "inherit";
  }

  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "#000000" : "#FFFFFF";
}

function updateElementColor(el: HTMLElement) {
  Vue.nextTick(() => {
    const computedStyle = getComputedStyle(el);
    const backgroundColor = computedStyle.backgroundColor;
    const contrastColor = getContrastColor(backgroundColor);

    el.style.color = contrastColor;
  });
}

/**
 * Diretiva v-contrast
 * Calcula a cor de fundo do elemento onde é aplicada e define
 * uma cor de texto contrastante.
 */
Vue.directive("contrast", {
  inserted(el: HTMLElement) {
    updateElementColor(el);
  },
  componentUpdated(el: HTMLElement) {
    updateElementColor(el);
  },
});
